import React, { createContext, useContext, useState, ReactNode } from 'react';
import LoaderLogo from '../components/atoms/LoaderLogo/LoaderLogo'; // <--- IMPORTA TU LOGO

interface LoaderContextType {
    isLoading: boolean;
    showLoader: () => void;
    hideLoader: () => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showLoader = () => setIsLoading(true);
    const hideLoader = () => setIsLoading(false);

    return (
        <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
            {children}

            {/* RENDERIZADO DEL LOADER GLOBAL */}
            {isLoading && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm transition-opacity duration-300">
                    {/* Contenedor del logo con animación */}
                    <div className="animate-pulse">
                        <LoaderLogo />
                    </div>
                </div>
            )}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error('useLoader debe usarse dentro de un LoaderProvider');
    }
    return context;
};